const comparisonCards = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Best Pricing',
    desc: 'Compare seller prices across the kakobuy spreadsheet to find the lowest markup. Our data refreshes every 24 hours.',
    highlight: 'Save Up to 40%',
  },
  {
    icon: 'ri-archive-line',
    title: 'Stock Availability',
    desc: 'Real-time stock tracking through the kakobuyspreadsheet database. Never click a dead link again.',
    highlight: 'Live Inventory',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Speed',
    desc: 'Filter sellers by shipping time in your kakobuy spreadsheet. Find the fastest delivery options globally.',
    highlight: '3-15 Days Avg',
  },
  {
    icon: 'ri-star-smile-line',
    title: 'Reputation Score',
    desc: 'Every seller in our best kakobuy spreadsheet carries a transparency rating based on buyer reviews and return rates.',
    highlight: 'Verified Sellers',
  },
];

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Seller Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            <span className="text-primary-600">Kakobuy Spreadsheet</span> Seller Comparison
          </h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto mt-4 leading-relaxed">
            Not all sellers are equal. Use our <strong>kakobuy spreadsheet</strong> comparison tools to evaluate pricing, stock reliability, shipping performance, and reputation before clicking buy.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comparisonCards.map((card) => (
            <div
              key={card.title}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${card.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2">{card.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">{card.desc}</p>
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                {card.highlight}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}